import { render, staticRenderFns } from "./ProfileAttributeEditor.vue?vue&type=template&id=31b10c1f&scoped=true"
import script from "./ProfileAttributeEditor.vue?vue&type=script&lang=ts"
export * from "./ProfileAttributeEditor.vue?vue&type=script&lang=ts"
import style0 from "./ProfileAttributeEditor.vue?vue&type=style&index=0&id=31b10c1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b10c1f",
  null
  
)

export default component.exports